module.exports = __webpack_public_path__ + "static/black-text-section-783d32ff29a522860ffb2141ef74cb10.jpg";